export enum ActiveLayerTypes {
  DEPOTS = "depot",
  SCHEDULED_JOURNEY = "scheduledJourney",
  RESULT = "result",
  ALL_JOURNEYS = "allJourneys",
  PARCEL = "parcel",
  NONE = "none",
  LEZ = "LEZ",
}
